import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { permissionObj } from '../../../../../Helpers/permission';
import { TRAFFIC_SUB_VIEW_MODEL } from '../../Model/Model';
import CustomAutocompleteSearch from "../../../../../components/CustomAutocompleteSearch";
import {TAB_OPTIONS} from "../Model/Model";
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";
import React from "react";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const TrafficFinesMainHeader = ({
    subView,
    handleSubViewChange,
    searchElement,
    setSearchElement,
    permission,
    DEV,
    selectedInnerView,
    selectEmployee,
    setSelectEmployee,
    bodyAutocompleteSearch,
    option,
    reset,
    setReset,
    rowsPerPage,
    setSearchResults,
    searchResults,
    setSearch,
    simpleSearch,
    setSimpleSearch,
                                    setBodyForExport
}) => {

    return (
        <div className='d-flex'>
            <div className=''>
                <div className='d-flex'>
                    {(DEV ||
                        permission?.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ) ||
                        permission?.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_READ)) && (
                        <ButtonAction
                            extraClassName='w-100 btn-icon-svg-general'
                            id='btn_tfmh_dashboard'
                            name='dashboard'
                            className={TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                            disabled={false}
                            splitName={false}
                            onClick={() => {
                                handleSubViewChange(TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD)
                            }}
                        />
                    )}

                    {(DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_USERS_READ)) && (
                        <ButtonAction
                            extraClassName='w-100 btn-icon-svg-general'
                            id='btn_tfmh_users'
                            name='users'
                            className={
                                TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS === subView
                                    ? 'btn-outlined-secondary-600-100 mr-8px'
                                    : 'btn-outlined-secondary-600-00 mr-8px'
                            }
                            disabled={false}
                            splitName={false}
                            onClick={() => {
                                handleSubViewChange(TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS);
                            }}
                        />
                    )}
                </div>
            </div>
            <div className='w-100'>
                {selectedInnerView === TAB_OPTIONS.FINES ? (
                    <div className={'pb-13px'}>
                        <CustomAutocompleteSearch
                             id="slt_tfmh_employee"
                            itemSelected={selectEmployee}
                            setItemSelected={setSelectEmployee}
                            bodyApi={bodyAutocompleteSearch}
                            model={option}
                             onReset ={()=>{
                                 setSelectEmployee(null)
                                 setReset(!reset)
                            }}
                            reset={false}
                            listTransform={userListToLabelEmailPhoneValue}
                            Icon={PersonChipBlack}
                        />
                    </div>
                ) :
                    subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS ?
                    <SearchSimple
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearchResults={setSearchResults}
                        searchResults={searchResults}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                        setBodyForExport={setBodyForExport}
                    />
                    :
                    <CustomSearch
                        id={"txt_tfmh_search"}
                        label={'type_something_to_search'}
                        value={searchElement}
                        setValue={setSearchElement}
                        onChange={(e) => setSearchElement(e.target.value)}
                        onReset={()=> setSearchElement("")}
                    />
                }
            </div>
        </div>)
}

export default TrafficFinesMainHeader
